import type { ButtonHTMLAttributes, Ref } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const iconButtonVariants = cva(
  "inline-flex items-center justify-center rounded-md transition-colors disabled:opacity-40 disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        default: "text-fg-2 border border-transparent hover:bg-bg-2 hover:text-fg-1",
        active: "text-fg-1 bg-accent/12 border border-primary-container/30",
        danger: "text-sev-crit border border-transparent hover:bg-sev-crit-bg/15",
      },
      size: {
        sm: "size-8",
        md: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  },
);

export interface IconButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof iconButtonVariants> {
  ref?: Ref<HTMLButtonElement>;
}

export function IconButton({
  variant = "default",
  size = "md",
  className,
  children,
  ref,
  ...rest
}: IconButtonProps) {
  return (
    <button
      ref={ref}
      type={rest.type ?? "button"}
      className={cn(iconButtonVariants({ variant, size }), className)}
      {...rest}
    >
      {children}
    </button>
  );
}
